import { FC, useMemo } from "react";
import { SuccinctReport } from "@vviinn/user-managment-client-ts";

import { useAppSelector } from "../../../store";

import { SubtitleItem } from "../../../components/GeneralUI/DetailedCardComponents";
import { DynamicFormCardWrapperProps } from "./components/DynamicFormCardWrapper";
import { Restricted } from "../../../components/Restricted";
import { CompanyPricingItem } from "./components/CompanyPricingItem";
import { Invoices } from "./Invoices";
import { ChevronIcon } from "../../../components/GeneralUI";

const reportSubtitle = ({
  created,
  updated,
}: Partial<SuccinctReport>): SubtitleItem[] | undefined => {
  const relevantTexts: string[] = [];
  if (created) {
    relevantTexts.push(`Created: ${created}`);
  }
  if (updated) {
    relevantTexts.push(`Updated: ${updated}`);
  }
  if (!relevantTexts.length) return undefined;
  else return relevantTexts.map((text: string) => ({ type: "text", text }));
};

const reportDataToCard = ({
  action,
  created,
  updated,
  period,
}: SuccinctReport): DynamicFormCardWrapperProps => ({
  title: period,
  navigateUrl:
    action.navigateUrl ??
    `/company/${action.parameters.form.companyId}/contract/${action.parameters.form.contractId}/plan/${action.parameters.form.planId}/${action.formType}/${action.parameters.form.id}`,
  enabled: true,
  subtitles: reportSubtitle({ created, updated }),
});

export const Billing: FC = () => {
  const reports = useAppSelector((state) => state.company.company?.reports);
  const currentCompanyId = useAppSelector((state) => state.company.company?.id);

  const reportsCardsData = useMemo(
    () =>
      reports?.items?.all.map((report) => ({
        ...reportDataToCard(report),
        iconAtRight: <ChevronIcon />,
      })) ?? [],
    [reports?.items?.all],
  );

  return (
    <Restricted permissions="company:reports:view">
      <CompanyPricingItem
        type="reports"
        cardsData={reportsCardsData}
        warning={reports?.warning}
        itemCreateAction={reports?.actions.create}
      />
      {currentCompanyId && <Invoices companyId={currentCompanyId} />}
    </Restricted>
  );
};
